import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Button, Select, Tooltip, Input } from 'components';
import { AddIcon, DeleteIcon, CheckIcon, ExisIcon, DownloadIcon, EditIcon } from 'assets/icons';
import { Globals, Constants } from 'utils';
import { UserService } from 'services';
import moment from 'moment';
import CreatePayment from "./modal-create";
import CreatePaymentCash from "./modal-create-cash";
import CreatePaymentMobile from "./modal-create-mobile";
import CreatePaymentZelle from "./modal-create-zelle";

interface Props extends RouteComponentProps {
	dispatch: any;
}

const INITIAL_STATE = {
	payment_method_id: '',
	since: '',
	until: '',
	search: '',
	status: '',
	motive: '',
};

class Payments extends React.Component<Props> {
	state = {
		data: [] as any[],
		page: 1,
		last_page: 1,
		header: [
			'Fecha de pago',
			'Nombre',
			'CI/RIF',
			'Mótivo',
			'Total($)',
			'Método de pago',
			'Referencia bancaria',
			'Vigencia',
			'Estatus',
			'Nombre Vendedor',
			'Código Vendedor',
			'Acciones',
		],
		form: INITIAL_STATE,
		createVisible: false,
		viewVisible: false,
		currentItem: null as any,
		paymentMethods: [] as any[],
		plans: [] as any[],
	};

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Registro de pagos',
				onBack: null,
			},
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: '',
			},
		});

		this.getSelects();
		this.load();
	}

	getSelects = async (withoutLoading: boolean = false) => {
		const res: any = await UserService.admin.getSelects({
			...this.state.form,
		});

		const formattedPaymentMethods = (res.paymentMethods || []).map((method: any) => ({
			id: method.id,
			name: method.name
		}));

		this.setState({
			paymentMethods: formattedPaymentMethods,
			plans: res.plans,
		});
	};

	load = async (withoutLoading: boolean = false) => {
		const res: any = await UserService.admin.allPayments({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since ? moment(this.state.form.since).format('YYYY-MM-DD') : '',
			until: this.state.form.until ? moment(this.state.form.until).format('YYYY-MM-DD') : '',
		});
		this.setState({
			data: res.payments?.rows || [],
			last_page: res.payments?.count || 1,
		});
	};

	reset = () => {
		this.setState(
			{
				form: INITIAL_STATE,
				page: 1,
			},
			() => this.load(true),
		);
	};

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value,
			},
		});
	};

	changeDate = (field: string, value: any) => {
		const dateValue = value && value.target ? value.target.value : value;
		this.setState({
			form: {
				...this.state.form,
				[field]: dateValue,
			},
		});
	};

	applyFilters = () => {
		this.setState(
			{
				page: 1,
			},
			() => this.load(true),
		);
	};

	openCreate = () => {
		this.setState({
			createVisible: true,
			currentItem: null,
		});
	};

	closeCreate = (reload: boolean = false) => {
		this.setState({
			createVisible: false,
			currentItem: null,
		});

		if (reload) this.load();
	};

	openView = (item: any) => {
		this.setState({
			currentItem: item,
			viewVisible: true,
		});
	};

	closeView = () => {
		this.setState({
			currentItem: null,
			viewVisible: false,
		});
	};

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			createVisible: true,
			currentItem: item,
		});
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el pago?', async () => {
			await UserService.admin.deletePayment({
				plan_payment_id: item.id,
			});
			this.load(true);
		});
	};

	approveOrReject = async (e: any, item: any, status: number) => {
		e.preventDefault();
		Globals.confirm(`¿Desea ${status === Constants.PLAN_PAYMENT_STATUS.ACCEPTED ? 'aprobar' : 'rechazar'} este pago?`, async () => {
			await UserService.admin.approveOrRejectPayment({
				id: item.id,
				status,
			});
			this.load(true);
		});
	};

	print = async () => {
		const res: any = await UserService.admin.allPayments({
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since ? moment(this.state.form.since).format('YYYY-MM-DD') : '',
			until: this.state.form.until ? moment(this.state.form.until).format('YYYY-MM-DD') : '',
			download: true,
		});
		if (res.url) {
			const link = document.createElement('a');
			link.href = res.url;
			link.download = res.url.split('/').pop();
			link.target = '_blank';
			link.click();
			link.remove();
		}
	}

	render() {
		const { createVisible, currentItem } = this.state;

		return (
			<div id="admin-notifications">
				{(createVisible && !currentItem) && (
					<CreatePayment onClose={() => this.closeCreate()} onSubmit={() => this.closeCreate(true)} />
				)}
				{(createVisible && currentItem?.payment_method_id === Constants.PAYMENT_METHODS.CASH) && (
					<CreatePaymentCash item={currentItem} onClose={() => this.closeCreate()} onSuccess={() => this.closeCreate(true)} />
				)}
				{(createVisible && currentItem?.payment_method_id === Constants.PAYMENT_METHODS.MOVIL) && (
					<CreatePaymentMobile item={currentItem} onClose={() => this.closeCreate()} onSuccess={() => this.closeCreate(true)} />
				)}
				{(createVisible && currentItem?.payment_method_id === Constants.PAYMENT_METHODS.ZELLE) && (
					<CreatePaymentZelle item={currentItem} onClose={() => this.closeCreate()} onSuccess={() => this.closeCreate(true)} />
				)}

				{/* Filtros */}
				<div className="row row-filter">
					<div className="col-md-2">
						<Input
							value={this.state.form.search}
							name="search"
							label="Nombre o CI/RIF"
							placeholder="Buscar"
							className="input-table"
							onChange={this.change}
						/>
					</div>

					<div className="col-md-2">
						<Select
							label="Mótivo de pago"
							name="motive"
							onChange={this.change}
							value={this.state.form.motive}
							options={[
								{ value: '', label: 'Todos' },
								{ value: 'plan_user_id', label: 'Membresía' },
								{ value: 'advertisement_id', label: 'Banners/Clasificados' },
								{ value: 'consultation_request_id', label: 'Teleconsultas' },
							]}
						/>
					</div>

					<div className="col-md-2">
						<Select
							label="Método de pago"
							name="payment_method_id"
							onChange={this.change}
							value={this.state.form.payment_method_id}
							options={[
								{ value: '', label: 'Todos' },
								...this.state.paymentMethods.map((i: any) => ({
									value: i.id,
									label: i.name
								}))
							]}
						/>
					</div>

					<div className="col-md-2">
						<Select
							label="Estatus"
							name="status"
							onChange={this.change}
							value={this.state.form.status}
							options={[
								{ value: '', label: 'Todos' },
								{ value: '0', label: 'Pendiente' },
								{ value: '1', label: 'Aprobado' },
								{ value: '2', label: 'Rechazado' },
							]}
						/>
					</div>

					<div className="col-md-2">
						<DatePicker
							label="Desde"
							name="since"
							value={this.state.form.since}
							onChange={(value: any) => this.changeDate('since', value)}
						/>
					</div>
					<div className="col-md-2">
						<DatePicker
							label="Hasta"
							name="until"
							value={this.state.form.until}
							onChange={(value: any) => this.changeDate('until', value)}
						/>
					</div>
					<div className="col-md-3 filter-actions">
						<Button className="btn-filter" onClick={this.applyFilters}>
							Filtrar
						</Button>

						{this.state.form !== INITIAL_STATE && (
							<Button className="btn-clean" onClick={this.reset}>
								Limpiar
							</Button>
						)}
					</div>
				</div>

				{/* Tabla */}
				<Table
					title="Registro de pagos"
					data={this.state.data.length}
					rightAlign={[4]}
					header={this.state.header}
					titleRight={
						<>
							<Button className="btn-download" onClick={() => this.print()}>
								<img src={DownloadIcon} alt="" aria-hidden="true" />
								<span>Descargar Excel</span>
							</Button>

							<Button className="btn-add-notification" onClick={this.openCreate}>
								<img src={AddIcon} alt="" aria-hidden="true" />
								Registrar pago
							</Button>
						</>
					}
				>
					{this.state.data.map((i: any, index: number) => {
						return (
							<tr key={index}>
								<td>{i.date_es}</td>
								<td>{i.payment_emisor?.name ?? ''}</td>
								<td>{i.payment_emisor?.document_format ?? ''}</td>
								<td>{i.motive_text ?? '-'}</td>
								<td>{Globals.formatMiles(i.amount)}</td>
								<td>{i.payment_method?.name ?? ''}</td>
								<td>{i.reference ?? ''}</td>
								<td>{i.vigency_txt ?? ''}</td>
								<td>{i.status_text ?? ''}</td>

								<td>{i.seller?.name ?? '-'}</td>

								<td style={{ fontWeight: '500' }}>{i.seller?.code ?? '-'}</td>

								<td className="text-right">
									{
										i?.status === Constants.PLAN_PAYMENT_STATUS.PENDING && (
											<Tooltip title="Aprobar">
												<button
													type="button"
													className="link-icon"
													onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
														e.preventDefault();
														e.stopPropagation();
														this.approveOrReject(e, i, Constants.PLAN_PAYMENT_STATUS.ACCEPTED);
													}}
													aria-label="Aprobar pago"
													style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
												>
													<img src={CheckIcon} alt="Aprobar" />
												</button>
											</Tooltip>
										)
									}

									{
										i?.status === Constants.PLAN_PAYMENT_STATUS.PENDING && (
											<Tooltip title="Rechazar">
												<button
													type="button"
													className="link-icon"
													onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
														e.preventDefault();
														e.stopPropagation();
														this.approveOrReject(e, i, Constants.PLAN_PAYMENT_STATUS.REJECTED);
													}}
													aria-label="Rechazar pago"
													style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
												>
													<img src={ExisIcon} alt="Rechazar" />
												</button>
											</Tooltip>
										)
									}

									<Tooltip title="Editar">
										<a className="link-icon" href="#" onClick={(e: any) => this.edit(e, i)}>
											<img src={EditIcon} alt="Editar" />
										</a>
									</Tooltip>

									<Tooltip title="Eliminar">
										<a className="link-icon" href="#" onClick={(e: any) => this.delete(e, i)}>
											<img src={DeleteIcon} alt="Eliminar" />
										</a>
									</Tooltip>
								</td>
							</tr>
						);
					})}
				</Table>

				<Pagination
					pages={this.state.last_page}
					active={this.state.page}
					onChange={async (page: number) => {
						await this.setState({
							page,
						});
						this.load();
					}}
				/>
			</div>
		);
	}
}

export default connect((state: RootState) => {
	return {};
})(Payments);